import { render, staticRenderFns } from "./createAddEditPostDialog.vue?vue&type=template&id=2be66efd&scoped=true"
import script from "./createAddEditPostDialog.vue?vue&type=script&lang=js"
export * from "./createAddEditPostDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be66efd",
  null
  
)

export default component.exports